export const notificationConstant = {
    IS_FETCHING : "IS_FETCHING",
    SHOW_LOADER: 'SHOW_LOADER',
    HIDE_LOADER: 'HIDE_LOADER'
};
